import React from 'react'
import { Box, Typography } from '@mui/material';

const StudentHistoryTools = (props) => {
  return (
    <Box
    sx={{
      mb: '10px',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    }}
    >
      <Typography sx={{ m: 1 }} variant="h5">
        Student
      </Typography>
    </Box>
  )
}

export default StudentHistoryTools
